"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoCode = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = require("modals/base");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var _noty = require("noty");

var _class, _descriptor, _temp, _class3;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var NoOp = function NoOp() {};

var PromoCodeModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(PromoCodeModal, _ReactModal);

  function PromoCodeModal(objectId) {
    var _this;

    var refreshPurchaseHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _userProfile.userProfileUpdated;
    babelHelpers.classCallCheck(this, PromoCodeModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PromoCodeModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('promo-code-modal');

    _this.setComponent(_react.default.createElement(PromoCode, {
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)),
      objectId: objectId,
      refreshHandler: refreshPurchaseHandler
    }));

    return _this;
  }

  return PromoCodeModal;
}(_base.ReactModal);

exports.default = PromoCodeModal;
var PromoCode = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PromoCode, _Component);

  function PromoCode() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, PromoCode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PromoCode)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this2.state = {
      submissionComplete: false,
      submitting: false,
      code: ""
    };
    babelHelpers.initializerDefineProperty(_this2, "objectId", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(PromoCode, [{
    key: "setValue",
    value: function setValue(questionId, answer) {
      this.setState(babelHelpers.defineProperty({}, questionId, answer));
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.submitting) return false;
      return !!this.state.code;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.props.modal.element.firstElementChild.addEventListener('scroll', function () {
        _this3.tempScrollPosition = _this3.props.modal.element.firstElementChild.scrollTop;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.modal.element.firstElementChild.scrollTop = this.tempScrollPosition;
    }
  }, {
    key: "render",
    value: function render() {
      var spin = {};
      if (!this.canSubmit()) spin['data-spin'] = 'true';
      return _react.default.createElement("form", {
        className: "promo-code-body",
        onSubmit: this.submitCode
      }, _react.default.createElement("h1", null, "Discount Code"), this.state.error && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error === true ? 'This code is no longer valid or incorrect. Please try again.' : this.state.error), _react.default.createElement(PromoCodeItem, {
        id: "code",
        type: "textField",
        setValue: this.setValue,
        value: this.state.code,
        key: "code",
        disabled: this.state.submitting
      }), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", _extends({
        className: _classList.default.join('btn btn-primary', !this.canSubmit && 'spinning')
      }, spin, {
        disabled: !this.canSubmit()
      }), "Submit")));
    }
  }, {
    key: "submitCode",
    value: function submitCode(event) {
      var _this4 = this;

      event.preventDefault();

      if (this.state.submitting) {
        return;
      }

      this.setState({
        error: false,
        submitting: true
      }, function () {
        (0, _fetch.default)("data/promo-code/submit", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            object: _this4.objectId,
            code: _this4.state.code
          })
        }).then(function (result) {
          if (result.ok) {
            return result.status == 204 ? true : result.json();
          }

          return result.json().then(function (value) {
            throw value;
          });
        }).then(function () {
          (0, _noty.showNotificationText)('Your code has been applied.');

          _this4.setState({
            applying: true
          });

          _this4.props.refreshHandler().then(function () {
            return _this4.props.modal.hide();
          });
        }).catch(function (e) {
          if (e.invalidCode) _this4.setState({
            error: true,
            submitting: false
          });else if (e.alreadyUsed) _this4.setState({
            error: 'You have already used this code.',
            submitting: false
          });else if (e.cannotUse) _this4.setState({
            error: 'You already have a discount on this item. This code does not apply.',
            submitting: false
          });else _this4.setState({
            error: true,
            submitting: false
          });
        });
      });
    }
  }]);
  return PromoCode;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "objectId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitCode", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitCode"), _class.prototype)), _class);
exports.PromoCode = PromoCode;

var PromoCodeItem = function PromoCodeItem(props) {
  var Type = PromoCode[props.type];
  return _react.default.createElement(Type, props);
};

PromoCode.textField = (_class3 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(_class3, _Component2);

  function _class3() {
    babelHelpers.classCallCheck(this, _class3);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class3).apply(this, arguments));
  }

  babelHelpers.createClass(_class3, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        name: id,
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled
      }));
    }
  }]);
  return _class3;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setValue"), _class3.prototype)), _class3);